import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { z } from 'src/lib'
import { EntityWithIdAndDescription, EntityWithIdAndDescriptionFields } from 'src/types'

const schema = z.array(
    z.object({
        [EntityWithIdAndDescriptionFields.Id]: z.number(),
        [EntityWithIdAndDescriptionFields.Description]: z.string()
    })
)

export const getArchivoTipos = (): Promise<EntityWithIdAndDescription[]> => {
    const endpoint = 'cache/archivos/tipos' // TODO: endpoints a archivo

    return HttpAxiosRequest.get(endpoint)
        .then(response => {
            const parsed = schema.safeParse(response)

            if (!parsed.success) {
                return Promise.reject('Error de validación.')
            }

            return Promise.resolve(parsed.data)
        })
        .catch(() => {
            return Promise.reject('Error de red.')
        })
}
